// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3F-_O","title":"BackImages_title__2Tbfa","images":"BackImages_images__1qof7"};